import { ModelResponse, Profile, Subscription, Workflow } from '../types/types';

export interface WorkflowState {
  subscription: Subscription;
  profile: Profile;
  conversation: ModelResponse[];
  workflow: Workflow;
  error: boolean;
}

export const initialWorkflowState: WorkflowState = {
  subscription: {
    subscriptionId: '',
    skuId: '',
    workflowData: [],
    promptVersion: '',
  },
  profile: {
    profileId: '',
    email: '',
    name: '',
    sub: '',
    appProfile: {
      jobDescription: '',
      department: '',
      additionalInfo: '',
    },
  },
  conversation: [
    {
      usedModel: '',
      responses: '',
      promptTokens: 0,
      completionTokens: 0,
    },
  ],
  workflow: {
    uid: '',
    name: '',
    status: '',
    creationDate: '',
    promptVersion: '',
    activeStep: 0,
    step: 0,
    subscriptionId: '',
    promptWorkflow: {
      userInputs: {
        postDescription: '',
        postGoal: '',
        postAudience: '',
        postTone: '',
      },
      aiResults: {
        postDescription: '',
        postGoal: '',
        postFinal: '',
        fileSummary: '',
      },
      uploadedFiles: [],
    },
    runningProcesses: [],
    resultEditing: {
      postContent: '',
    },
  },
  error: false,
};

export interface LoadedState {
  subscription: boolean;
  profile: boolean;
  workflow: boolean;
}

export const initialLoadedState: LoadedState = {
  subscription: false,
  profile: false,
  workflow: false,
};
